import { IValueInputAttachable } from "client/Forms/attachable";
import { ReactElement } from "react";
import { localize } from "client_legacy/ndaw/culture";
import { PredefinedRssAppTab, RssFeedModel } from "client/Api/Workspace/workspace";
import { EditRssTileFeedInfo } from "./EditRssTileFeedInfo";
import { ValidationError } from "client/Components";

export type PredefinedRssTabContentProps = {
	predefinedTabHandler: IValueInputAttachable<PredefinedRssAppTab>;
	predefinedAppTabsData: Map<number, RssFeedModel>;
};

export const PredefinedRssTabContent = (props: PredefinedRssTabContentProps): ReactElement => {
	const {
		predefinedTabHandler
	} = props;

	const {
		feedId
	} = predefinedTabHandler.value;

	const tabData: RssFeedModel | undefined = props.predefinedAppTabsData.get(feedId);

	if(!tabData){
		throw new Error(`There is no data for the tab with id ${feedId}`);
	}

	return (
		<>
			<ValidationError {...predefinedTabHandler.for("feedId").attachToValidationError()} />
			<EditRssTileFeedInfo
				title={localize("_RssFeedUrl")}
				text={tabData.feedUrl}
			/>
			<EditRssTileFeedInfo
				title={localize("_SiteUrl")}
				text={tabData.siteUrl}
			/>
		</>
	);
};

PredefinedRssTabContent.displayName = "PredefinedRssTabContent";